import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {
  private cardTypeMatchers = [
    { type: 'Visa', pattern: /^4/ },
    { type: 'MasterCard', pattern: /^5[1-5]/ },
    { type: 'American Express', pattern: /^3[47]/ },
    { type: 'Discover', pattern: /^6/ },
  ];

  validateCardType(cardNumber: string): string {
    const cleanedNumber = cardNumber.replace(/\s/g, ''); 
    
    for (const cardType of this.cardTypeMatchers) {
      if (cardType.pattern.test(cleanedNumber)) {
        return cardType.type;
      }
    }

    return 'Unknown';
  }
}
